import { getSetup } from './getSetup';
import { fetchAccessToken } from './fetchAccessToken';

type LabelInfo =
	| {
			hash: string;
			fileType: string;
			accessToken: string;
	  }
	| undefined;

export default async function fetchMultiLangLabel(
	uidEnergyLabel: string
): Promise<LabelInfo> {
	const setup = getSetup();

	const deliveryUrl =
		localStorage.getItem('use_qs') === 'true'
			? setup.market.qsUrl
			: setup.market.urls.delivery;
	try {
		const accessToken = navigator.onLine
			? await fetchAccessToken()
			: localStorage.getItem('accesstoken');
		console.log('accessToken', accessToken);
		const resp = await fetch(
			`${deliveryUrl}/module/delivery/bpca/api/v2/contents?fields-preset=full`,
			{
				headers: {
					Authorization: `Bearer ${accessToken}`,
					// 'Service-Worker': 'false',
					'Cache-Control': 'max-age=0',
				},
			}
		);

		console.log('Resp', resp);

		if (!resp.ok) {
			console.error(`Fetch failed with status: ${resp.status}`);
			return undefined;
		}
		console.log('after !resp.ok');
		const data = await resp.json();
		if (!data?.Contents || !Array.isArray(data.Contents)) return undefined;
		const project = data.Contents.find(
			(e: any) => e.Uid === uidEnergyLabel
		);
		if (!project) return undefined;
		console.log('after !project');
		const hash = project.AssetDataSet?.AssetFileProperties?.FileHash;
		const fileType =
			project.AssetDataSet?.AssetFileProperties?.FileType?.toLowerCase();
		if (!hash || !fileType) return undefined;
		console.log('after !hash etc', hash, fileType, accessToken);
		return { hash, fileType, accessToken };
	} catch {
		return undefined;
	}
}
